module.exports = __webpack_public_path__ + "img/ic-refund-yellow.e8725a11.svg";